import React, { useState, useEffect } from "react";
import { Select, Form, Input, Checkbox, DatePicker, InputNumber, Switch } from "antd";
import "./form-list.less";
import { Uploader, lib, MultipleUploader } from "react-single-app";

const FormItem = Form.Item;
const Option = Select.Option;
const { TextArea } = Input;
const { RangePicker } = DatePicker;

/**
 * @param detail 当前编辑对象
 * @param configList 配置列表
 * ```
 * {type: 'SELECT', labelKey: '', labelName: '', xhr: '请求链接', list: [], placeholder: '', required: false, message: '请输入', }
 * ```
 * @param form form
 */

function FormList({ detail, configList, form, refresh, children, formItemLayout }) {
    let [address, setAddress] = useState([[], [], []]);
    function switchType(item) {
        switch (item.type) {
            case "INPUT":
                return (
                    <Input
                        value={item.value}
                        disabled={item.disabled}
                        placeholder={item.placeholder || `请输入${item.labelName}`}
                        onFocus={e => (item.onFocus ? item.onFocus(form) : {})}
                        onBlur={e => (item.onBlur ? item.onBlur(form) : {})}
                        maxLength={item.maxLength || 9999}
                        autoComplete={item.autoComplete || null}
                    />
                );
            case "INPUTNUMBER":
                return (
                    <InputNumber
                        disabled={item.disabled}
                        max={item.max}
                        min={item.min}
                        precision={item.precision}
                    />
                );
            case "SELECT":
                return (
                    <Select
                        allowClear
                        onChange={
                            item.onChange
                                ? (e, target) => item.onChange(e, form, target)
                                : (e, target) => {}
                        }
                        mode={item.mode}
                        style={{ width: "100%" }}
                        showSearch
                        placeholder={item.placeholder}
                        disabled={item.disabled}
                        filterOption={(inputVal, option) => {
                            return option.children?.startsWith(inputVal);
                        }}>
                        {item.list &&
                            item.list.length &&
                            item.list.map((ite, index) => {
                                return (
                                    <Option option={ite} value={ite.value || ite.id} key={index}>
                                        {ite.name}
                                    </Option>
                                );
                            })}
                    </Select>
                );
            case "CHECKBOX":
                return (
                    <Checkbox.Group disabled={item.disabled}>
                        {item.list &&
                            item.list.length &&
                            item.list.map((ite, index) => {
                                return (
                                    <Checkbox value={ite.value} key={index}>
                                        {ite.name}
                                    </Checkbox>
                                );
                            })}
                    </Checkbox.Group>
                );
            case "DATE":
                return <DatePicker showTime={item.showTime} disabled={item.disabled} />;
            case "DATERANGE":
                return <RangePicker showTime={item.showTime} disabled={item.disabled} />;
            case "TEXTAREA":
                return (
                    <TextArea
                        disabled={item.disabled}
                        placeholder={item.placeholder}
                        maxLength={item.maxLength || null}
                    />
                );
            case "SWITCH":
                return <Switch disabled={item.disabled} />;
            case "FILE":
                return (
                    <Uploader
                        onChange={src => {
                            console.log(src);
                        }}
                        style={item.style || { width: "60px", height: "40px" }}
                    />
                );
            case "FILELIST":
                return (
                    <MultipleUploader
                        multiple={item.multiple}
                        maxCount={item.maxCount}
                        onChange={src => {
                            console.log(src);
                        }}
                        disabled={item.disabled}
                        style={item.style || { width: "60px", height: "40px" }}
                    />
                );
            case "PASSWORD":
                return <Input.Password />;
            case "DECIMAL":
                return <InputNumber />;
            default:
                return null;
        }
    }

    let formLayout = formItemLayout || {
        labelCol: { span: 9 },
        wrapperCol: { span: 15 },
    };

    function getValue(detail, key) {
        let value;
        if (typeof key === "string") {
            if (key.indexOf(".") !== -1) {
                let arr = key.split(".");
                value = arr.reduce((val, current) => (val ? val[current] : null), detail);
            } else {
                value = detail[key];
            }
        } else if (typeof key === "object" && key instanceof Array) {
            value = key.reduce((val, current) => (val ? val[current] : null), detail);
        }
        return value;
    }

    function renderFormItem(item, rules) {
        switch (item.type) {
            case "TEXT":
                return !item.hide ? (
                    <div className="form-item">
                        {item.labelName}：
                        {detail
                            ? item.render
                                ? item.render(detail)
                                : getValue(detail, item.labelKey)
                            : null}
                    </div>
                ) : null;
            case "AREA":
                return (
                    <FormItem
                        required={item.requiredStyle || item.required}
                        className="area-form-item"
                        label={item.labelName}
                        validateStatus={item.validateStatus}
                        help={item.help}
                        rules={[
                            {
                                required: item.required,
                                message: "",
                            },
                        ]}>
                        <FormItem noStyle name={[...item.labelKey, "provinceCode"]}>
                            <Select
                                disabled={item.disabled}
                                labelInValue
                                showSearch
                                allowClear
                                placeholder={item.proPlaceholder}
                                style={{ width: 120 }}
                                optionFilterProp="children"
                                onChange={e => {
                                    form.setFields([
                                        {
                                            name: [...item.labelKey, "province"],
                                            value: e ? e.label : "",
                                        },
                                        {
                                            name: [...item.labelKey, "cityCode"],
                                            value: { value: "", name: "" },
                                        },
                                        { name: [...item.labelKey, "city"], value: "" },
                                        {
                                            name: [...item.labelKey, "zoneCode"],
                                            value: { value: "", name: "" },
                                        },
                                        { name: [...item.labelKey, "zone"], value: "" },
                                    ]);
                                    e && proGetAreaList(e.value, 1);
                                }}>
                                {address[0].map(item => (
                                    <Option value={item.id} key={item.id}>
                                        {item.name}
                                    </Option>
                                ))}
                            </Select>
                        </FormItem>
                        <FormItem noStyle name={[...item.labelKey, "cityCode"]}>
                            <Select
                                labelInValue
                                showSearch
                                allowClear
                                disabled={item.disabled}
                                placeholder={item.cityPlaceholder}
                                optionFilterProp="children"
                                style={{ width: 120 }}
                                onChange={e => {
                                    form.setFields([
                                        {
                                            name: [...item.labelKey, "city"],
                                            value: e ? e.label : "",
                                        },
                                        {
                                            name: [...item.labelKey, "zoneCode"],
                                            value: { value: "", name: "" },
                                        },
                                        { name: [...item.labelKey, "zone"], value: "" },
                                    ]);
                                    e && proGetAreaList(e.value, 2);
                                }}>
                                {address[1] &&
                                    address[1].map(item => (
                                        <Option value={item.id} key={item.id}>
                                            {item.name}
                                        </Option>
                                    ))}
                            </Select>
                        </FormItem>
                        <FormItem noStyle name={[...item.labelKey, "zoneCode"]}>
                            <Select
                                labelInValue
                                showSearch
                                allowClear
                                optionFilterProp="children"
                                disabled={item.disabled}
                                placeholder={item.zonePlaceholder}
                                style={{ width: 120 }}
                                onChange={e => {
                                    form.setFieldsValue({
                                        name: [...item.labelKey, "zone"],
                                        value: e ? e.label : "",
                                    });
                                    // e && proGetAreaList(e.value);
                                }}>
                                {address[2] &&
                                    address[2].map(item => (
                                        <Option value={item.id} key={item.id}>
                                            {item.name}
                                        </Option>
                                    ))}
                            </Select>
                        </FormItem>
                        <FormItem noStyle name={[...item.labelKey, "address"]}>
                            <Input
                                style={{ width: 200 }}
                                placeholder={item.addressPlaceholder}
                                disabled={item.disabled}
                                onFocus={e => (item.onFocus ? item.onFocus(form) : {})}
                                onBlur={e => (item.onBlur ? item.onBlur(form) : {})}
                            />
                        </FormItem>
                    </FormItem>
                );
            default:
                return !item.hide ? (
                    <FormItem
                        hidden={item.hidden}
                        {...formLayout}
                        label={item.labelName}
                        name={item.labelKey}
                        rules={rules}
                        required={item.requiredStyle || item.required}
                        help={item.help}
                        normalize={value => {
                            if (item.type === "DECIMAL") {
                                value = String(value);
                                if (value.indexOf(".") !== -1) {
                                    value = parseFloat(parseFloat(value).toFixed(item.digits));
                                }
                            }
                            return value;
                        }}>
                        {switchType(item)}
                    </FormItem>
                ) : null;
        }
    }

    useEffect(() => {
        configList.map(item => {
            if (item.type === "AREA" && lib.getParam("type") !== "watch") {
                let provinceCode = form?.getFieldValue([...item.labelKey, "provinceCode"]);
                if (provinceCode?.value) {
                    proGetAreaList("-1", 0).then(res =>
                        proGetAreaList(String(provinceCode.value), 1).then(() => {
                            let cityCode = form.getFieldValue([...item.labelKey, "cityCode"]);
                            proGetAreaList(String(cityCode.value), 2);
                        }),
                    );
                } else {
                    proGetAreaList("-1", 0).then();
                }
            } else if (item.type === "AREA") {
                proGetAreaList("-1", 0).then();
            }
        });
    }, [refresh]);

    function proGetAreaList(areaCode, key) {
        return new Promise((res, rej) => {
            if (String(key) === "undefined") {
                return;
            }
            lib.request({
                url: "/ares-web/area/search",
                data: { areaCode },
                success: json => {
                    if (key === 0) {
                        address[1] = [];
                        address[2] = [];
                    }
                    if (key === 1) address[2] = [];
                    address[key] = json;
                    let add = JSON.parse(JSON.stringify(address));
                    setAddress(add);
                    res();
                },
                fail: err => rej(err),
            });
        });
    }
    return (
        <div className="favour-form-list">
            {configList.map((item, index) => {
                let rules = [
                    {
                        required: item.required,
                        message:
                            item.message ||
                            `请${item.type === "SELECT" ? "选择" : "输入"}${item.labelName}`,
                    },
                ];
                if (item.max) {
                    rules[0].max = item.max;
                }
                if (item.validator) {
                    rules.push(item.validator);
                }
                return (
                    <FormItem noStyle key={index}>
                        {renderFormItem(item, rules)}
                    </FormItem>
                );
            })}
            {children ? (
                children instanceof Array ? (
                    children?.map((item, index) => (
                        <div key={index} style={{ display: "inline" }}>
                            {item}
                        </div>
                    ))
                ) : // ? children?.map(item => <div className="form-item">{item}</div>)
                children instanceof Object ? (
                    <>{children}</>
                ) : (
                    ""
                )
            ) : (
                ""
            )}
        </div>
    );
}

export default FormList;
